import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "../lib/api";
import { Seo, faqJsonLd } from "../lib/seo";
import { Section, SectionHead } from "../components/ui";
import { FaqAccordion } from "../components/marketing";

export default function Faq() {
  const { data } = useQuery({ queryKey: ["faqs"], queryFn: () => get("/faqs") });
  const [q, setQ] = useState("");
  const [active, setActive] = useState("");
  const categories = data?.categories || [];
  const faqs = data?.faqs || [];
  const filtered = useMemo(() => faqs.filter((f) =>
    (!q || (f.question + f.answer).toLowerCase().includes(q.toLowerCase())) && (!active || f.category === active)), [faqs, q, active]);
  const grouped = categories.map((c) => ({ cat: c, items: filtered.filter((f) => f.category === c) })).filter((g) => g.items.length);

  return (
    <>
      <Seo title="FAQ" path="/faq/" description="Answers to the questions teams ask before choosing BloomCONNECT — setup, pricing, credits, channels, AI, integrations and booking." jsonLd={faqJsonLd(faqs)} />
      <Section>
        <SectionHead label="FAQ" title="Questions buyers actually ask." />
        <div className="mt-8 grid gap-10 lg:grid-cols-[220px,1fr]">
          <aside className="lg:sticky lg:top-24 self-start">
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search questions" aria-label="Search FAQ" className="w-full rounded-xs border border-line px-3 h-10 text-sm bg-white mb-4" />
            <nav className="space-y-1">
              <button onClick={() => setActive("")} className={`block text-left text-sm py-1 ${!active ? "text-brand-700" : "text-ink-600"}`}>All categories</button>
              {categories.map((c) => (
                <button key={c} onClick={() => setActive(c)} className={`block text-left text-sm py-1 ${active === c ? "text-brand-700" : "text-ink-600 hover:text-ink-950"}`}>{c}</button>
              ))}
            </nav>
          </aside>
          <div className="space-y-12">
            {grouped.map((g) => (
              <div key={g.cat} id={g.cat.replace(/[^a-z]/gi, "-").toLowerCase()}>
                <h2 className="text-xl text-ink-950 mb-4">{g.cat}</h2>
                <FaqAccordion items={g.items} />
              </div>
            ))}
            {grouped.length === 0 && <p className="text-ink-400">No questions match your search.</p>}
          </div>
        </div>
      </Section>
    </>
  );
}
